import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { QueryValue } from './query-value.model';

export const FILTER_SCHEMA = Object.freeze({
  LABEL: '',
  QUERY_NAME: '',
  QUERY_VALUES: List<QueryValue>([]),
});
const RECORD = generateSchema(FILTER_SCHEMA);
const KEYS: any = generateKeys(FILTER_SCHEMA);

export class Filter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.QUERY_VALUES,
        value: props.get(KEYS.QUERY_VALUES)
          ? this.queryValues.map((params) => new QueryValue(params))
          : List<QueryValue>([]),
      },
    ]);

    return selfModel as Filter;
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get queryName(): string {
    return this.get(KEYS.QUERY_NAME);
  }

  get queryValues(): List<QueryValue> {
    return this.get(KEYS.QUERY_VALUES);
  }
}
